import { NAVI_AGENCY_CODE } from '@cp/pages/AllAgents/AgentForm/constants/constants';

const isNaviAgency = (agencyCode: string | undefined) => agencyCode === NAVI_AGENCY_CODE;

export default isNaviAgency;
